import { useQuery } from '@tanstack/react-query'

import axios from '@/_lib/axiosInstance'
import { ApiResponse, IMedanteCreditProgram } from '@/_types'

/**
 * Loads Medante credit program metadata for order steps that sell credit packages.
 *
 * @param id - Credit program id.
 */
export const fetchCreditProgram = async (
	id: number
): Promise<ApiResponse<IMedanteCreditProgram>> => {
	return axios
		.get<ApiResponse<IMedanteCreditProgram>>(`v1/web/creditPrograms/${id}`)
		.then(res => res.data)
}

/**
 * React Query hook for {@link fetchCreditProgram}; disabled when `id <= 0`.
 *
 * @param id - Credit program id.
 */
export const useGetCreditProgram = (id: number) => {
	return useQuery<ApiResponse<IMedanteCreditProgram>>({
		queryKey: ['credit-program', id],
		queryFn: () => fetchCreditProgram(id),
		enabled: id > 0,
		select: data => data
	})
}
